import { NotificationManager } from 'react-notifications';

// only create this in client side rendering
if (typeof NotificationManager !== 'undefined') {
  NotificationManager.removeAllNotifications = function () {
    this.listNotify = [];
    this.emitChange();
  };
}
